(function () {
  'use strict';

  var dataEl = document.getElementById('aiello-guide-data');
  if (!dataEl) return;

  var config;
  try { config = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var products = config.products;
  var matrix = config.matrix || {};
  var installRecs = config.installRecs || {};

  var state = { currentStep: 1, answers: { towels: null, line: null, installation: null } };

  var criteriaLabels = {
    towels: function (v) { return v + ' toalha' + (v > 1 ? 's' : ''); },
    line: function (v) { return v === 'inox' ? 'Inox 304' : 'Linha Classic'; },
    installation: function (v) { return v === 'obra' ? 'Banheiro em obra' : 'Banheiro já pronto'; }
  };

  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>';
  var ICON_AR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>';
  var ICON_TABLE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="1.5"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="9" y1="4" x2="9" y2="20"/></svg>';

  function showStep(n) {
    state.currentStep = n;
    document.querySelectorAll('[data-step-content]').forEach(function (el) { el.classList.add('is-hidden'); });
    var current = document.querySelector('[data-step-content="' + n + '"]');
    if (current) {
      current.classList.remove('is-hidden');
      current.style.animation = 'none';
      void current.offsetHeight;
      current.style.animation = '';
    }
    document.querySelectorAll('[data-step]').forEach(function (el) {
      var stepNum = parseInt(el.dataset.step, 10);
      el.classList.remove('is-active', 'is-completed');
      var numEl = el.querySelector('.aiello-gw__step-number');
      if (stepNum < n) { el.classList.add('is-completed'); if (numEl) numEl.textContent = '✓'; }
      else if (stepNum === n) { el.classList.add('is-active'); if (numEl) numEl.textContent = stepNum; }
      else if (numEl) numEl.textContent = stepNum;
    });
  }

  function selectOption(question, value) {
    state.answers[question] = value;
    if (state.currentStep < 3) setTimeout(function () { showStep(state.currentStep + 1); }, 200);
    else setTimeout(showResult, 300);
  }

  function goBack() { if (state.currentStep > 1) showStep(state.currentStep - 1); }

  // Aba do visualizador AR para este produto (some quando o produto nao tem 3D).
  function arTab(key) {
    var tab = document.querySelector('.gar__model-tab[data-product-key="' + key + '"]');
    return tab && tab.style.display !== 'none' ? tab : null;
  }
  function scrollTo(el) { if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  function toolsHtml(product) {
    var tab = arTab(product.ar_key);
    var compare = document.getElementById('aiello-guide-compare');
    return '<div class="aiello-gr__tools">' +
      (tab ? '<button type="button" class="aiello-gr__tool" data-ar-key="' + product.ar_key + '">' + ICON_AR + 'Ver na sua parede</button>' : '') +
      (compare ? '<a class="aiello-gr__tool" href="#aiello-guide-compare">' + ICON_TABLE + 'Comparar com os outros</a>' : '') +
      '</div>';
  }

  function showResult() {
    var rec = matrix[state.answers.towels + '-' + state.answers.line];
    var product = rec && products[rec.main];
    if (!product) return;

    var criteriaEl = document.getElementById('aiello-guide-criteria');
    if (criteriaEl) {
      criteriaEl.innerHTML = Object.keys(state.answers).map(function (k) {
        return '<span class="aiello-gr__criteria-tag">' + criteriaLabels[k](state.answers[k]) + '</span>';
      }).join('');
    }

    var mainEl = document.getElementById('aiello-guide-main-product');
    if (mainEl) {
      var features = (product.features_raw || '').split('\n').filter(Boolean).map(function (f) {
        return '<li class="aiello-gr__main-feature">' + ICON_CHECK + f.trim() + '</li>';
      }).join('');
      mainEl.innerHTML =
        '<div class="aiello-gr__main-image">' +
          '<span class="aiello-gr__main-badge">Ideal pra você</span>' +
          (product.image ? '<img src="' + product.image + '" alt="' + product.name + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="aiello-gr__main-body">' +
          '<span class="aiello-gr__main-line">LINHA ' + product.line + '</span>' +
          '<h3 class="aiello-gr__main-name">' + product.name + '</h3>' +
          (product.price ? '<p class="aiello-gr__price">A partir de <strong>' + product.price + '</strong></p>' : '') +
          '<p class="aiello-gr__main-desc">' + product.description + '</p>' +
          '<ul class="aiello-gr__main-features">' + features + '</ul>' +
          '<div class="aiello-gr__main-install">' +
            '<div class="aiello-gr__main-install-label">RECOMENDAÇÃO DE INSTALAÇÃO</div>' +
            '<div class="aiello-gr__main-install-text">' + (installRecs[state.answers.installation] || '') + '</div>' +
          '</div>' +
          '<div class="aiello-gr__main-cta">' +
            '<a href="' + product.url + '" class="aiello-btn aiello-btn--gold">Ver produto e preço</a>' +
            '<a href="' + (config.whatsapp_url || '#') + '" class="aiello-btn aiello-btn--outline-dark" target="_blank" rel="noopener">Falar no WhatsApp</a>' +
          '</div>' +
          toolsHtml(product) +
        '</div>';
    }

    var altEl = document.getElementById('aiello-guide-alt');
    var alt = rec.alt && products[rec.alt];
    if (altEl) {
      if (alt) {
        altEl.innerHTML =
          '<div class="aiello-gr__alt-img">' + (alt.image ? '<img src="' + alt.image + '" alt="' + alt.name + '" loading="lazy">' : '') + '</div>' +
          '<div><div class="aiello-gr__alt-label">Também serve</div><div class="aiello-gr__alt-name">' + alt.name + '</div>' +
          '<div class="aiello-gr__alt-reason">' + (rec.alt_reason || '') + '</div></div>' +
          '<div class="aiello-gr__alt-cta"><a href="' + alt.url + '" class="aiello-btn aiello-btn--outline-dark">Ver ' + alt.name + '</a></div>';
        altEl.classList.remove('is-hidden');
      } else {
        altEl.classList.add('is-hidden');
      }
    }

    var wizardEl = document.getElementById('aiello-guide-wizard');
    var resultEl = document.getElementById('aiello-guide-resultado');
    if (wizardEl) wizardEl.classList.add('is-hidden');
    if (resultEl) { resultEl.classList.remove('is-hidden'); setTimeout(function () { scrollTo(resultEl); }, 100); }
  }

  function restart() {
    state.currentStep = 1;
    state.answers = { towels: null, line: null, installation: null };
    var wizardEl = document.getElementById('aiello-guide-wizard');
    var resultEl = document.getElementById('aiello-guide-resultado');
    if (resultEl) resultEl.classList.add('is-hidden');
    if (wizardEl) { wizardEl.classList.remove('is-hidden'); showStep(1); setTimeout(function () { scrollTo(wizardEl); }, 100); }
  }

  document.addEventListener('click', function (e) {
    var option = e.target.closest('[data-question]');
    if (option) {
      var q = option.dataset.question;
      selectOption(q, q === 'towels' ? parseInt(option.dataset.value, 10) : option.dataset.value);
      return;
    }
    var ar = e.target.closest('[data-ar-key]');
    if (ar) {
      var tab = arTab(ar.dataset.arKey);
      if (tab) { tab.click(); scrollTo(tab.closest('section')); }
    }
  });

  document.querySelectorAll('.aiello-gw__back').forEach(function (btn) { btn.addEventListener('click', goBack); });
  var restartBtn = document.getElementById('aiello-guide-restart');
  if (restartBtn) restartBtn.addEventListener('click', restart);

  showStep(1);
})();
